import { useRainCorporateFormContext } from "@usher/pe-client-front-end-lib"
import { clsx } from "clsx"
import { CheckIcon } from "lucide-react"
import { FormattedMessage } from "react-intl"
import { Fragment } from "react/jsx-runtime"
import { GET_RAIN_LINKS } from "../links"

export const RainStep = () => {
  const { valid, verification } = useRainCorporateFormContext()
  return (
    <Fragment>
      {GET_RAIN_LINKS().map(({ title, route }) => {
        let isValid = ["", "company-address", "company-contact-details"].includes(route) || false
        if (route === "add-ubo") isValid = valid.ubo
        if (route === "add-representatives") isValid = valid.representative
        if (route === "add-business-offer") isValid = valid.officer
        if (route === "documents") isValid = ["21", "18", "22", "19"].every((id) => verification?.[id])
        return (
          <li className={clsx("welcome-info__controls-list", { active: isValid })}>
            <div className="dropright tooltips-ver">
              <FormattedMessage id={title} />
            </div>
            {isValid && (
              <div className="welcome-info__button-link">
                <CheckIcon size={18} color="lime" className="mt-[-2px]" />
              </div>
            )}
          </li>
        )
      })}
    </Fragment>
  )
}
